import React from "react"
import Button from "@components/objects/Button/Button"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import * as styles from "./LandingPageGuides.module.scss"

const LandingPageGuides = ({ featuredGuide, background }) => (
  <div
    className={styles.LandingPageGuides}
    style={background ? { backgroundImage: `url('${background.url}?fm=jpg&w=2000')` } : null}
  >
    <Section className={styles.section}>
      <SiteWrapper>
        <div className={styles.content}>
          <h3>HOPP Guides</h3>
          <h2>{featuredGuide.title}</h2>
          <Button
            className={styles.cta}
            color="pink"
            design="outline"
            text="Read Now"
            link={`/guides/${featuredGuide.slug}`}
          />
        </div>
      </SiteWrapper>
    </Section>
  </div>
)

export default LandingPageGuides
